import { css } from 'aphrodite';
import React from 'react';
import { Toggle } from '../../../../../../components/Toggle';
import { aceGray } from '../../../../../../styles/colors';
import { bs } from '../../../../../../styles/styles';
import { styleSheet } from '../styles';

interface FieldHeaderProps {
	fieldId: string;
	questionIndex: number;
	label: string;
	isRequired: boolean;
	onToggleCheckChanged: (index: number) => void;
}

export const FieldHeader = React.memo<FieldHeaderProps>(
	({ fieldId, questionIndex, label, isRequired, onToggleCheckChanged }) => {
		// Memoize expensive calculations
		const inputId = React.useMemo(
			() => `edit-custom-${fieldId}-question-${questionIndex}-input`,
			[fieldId, questionIndex]
		);

		const toggleId = React.useMemo(() => `toggle-${fieldId}-question-${questionIndex}`, [fieldId, questionIndex]);

		const displayLabel = React.useMemo(() => label || 'Question', [label]);

		// Memoize toggle handler
		const handleToggleCheckChanged = React.useCallback(
			() => onToggleCheckChanged(questionIndex),
			[onToggleCheckChanged, questionIndex]
		);

		return (
			<div className={css(bs.flex, bs.justifyBetween, bs.itemsCenter, bs.mb2)}>
				<label className={css(styleSheet.label)} htmlFor={inputId}>
					{displayLabel}
				</label>
				<div className={css(bs.flex, bs.gap2)}>
					<Toggle
						id={toggleId}
						isOn={isRequired}
						onToggleCheckChanged={handleToggleCheckChanged}
						uncheckedColor={aceGray}
					/>
					<span className={css(styleSheet.toggleLabel)}>Required</span>
				</div>
			</div>
		);
	}
);

FieldHeader.displayName = 'FieldHeader';
